<div class="home-career-wrapper w-100 H-100 H-100-full"
inViewport
[inViewportOptions]="{ threshold: [0] }"
(inViewportAction)="onIntersection($event)"
>
    <div class="content-wrapper" [ngClass]="{'animate':animateContent,
                                            'd-none': screenWidth > 1024}">
        <div class="content-container">
        <p class="heading5 career-header" [innerHtml]="content.header"></p>
        <h3 *ngIf="screenWidth > 767" class="heading3 font-bold heading-3-m" [innerHtml]="content.title"></h3>
        <h3 *ngIf="screenWidth <= 767" class="heading3 font-bold heading-3-m" [innerHtml]="content.title_mobile"></h3>
        </div>
        <div class="content-container-bottom">
             <a class="link1-mobile link-darker" href="mailto:{{content.button_email}}">{{content.button_label}}</a>
        </div>
    </div>
    <div class="image-wrapper"
        [ngClass]="{'animate':animateContent}"
        (swipeleft)="onSwipeLeft()"
        (swiperight)="onSwipeRight()">
        <div class="image-item" *ngFor="let gallery of careergallery; let i = index" [ngClass]="{'last-active':lastActive == i, 'active':activeSlide == i}">
             <img id="career-image-{{i}}" (load)="imageLoaded(i)" src="{{gallery.image}}" alt="">
        </div>
        <div class="dots-wrapper career-dots-wrapper">
            <a (click)="activeSlideDots(j)" class="gallery-dots" 
              *ngFor="let dots of careergallery;  let j = index">
                <div class="dots-inner-wrapper dark-dots" [ngStyle]="{'width': labelwidth +'px'}">
                    <mat-progress-bar *ngIf="activeSlide == j" mode="determinate" value="{{width}}"></mat-progress-bar>
                </div>
            </a>
        </div>
    </div>
    <div class="content-wrapper" [ngClass]="{'animate':animateContent,
                                             'd-none': screenWidth <= 1024}">
        <div class="content-container">
            <p class="heading5 career-header" [innerHtml]="content.header"></p>
            <h3 class="heading3 font-bold heading3-m" [innerHtml]="content.title"></h3>
        </div>
        <div class="content-container-bottom">
        <a class="link1 link-darker" href="mailto:{{content.button_email}}">{{content.button_label}}</a>
        </div>
    </div>
</div>
